import { render, staticRenderFns } from "./PropertyTypeStep.vue?vue&type=template&id=468bc741&scoped=true&"
import script from "./PropertyTypeStep.vue?vue&type=script&lang=js&"
export * from "./PropertyTypeStep.vue?vue&type=script&lang=js&"
import style0 from "./PropertyTypeStep.vue?vue&type=style&index=0&id=468bc741&lang=scss&scoped=true&"
import style1 from "./PropertyTypeStep.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468bc741",
  null
  
)

export default component.exports